import React from 'react';
import PropTypes from 'prop-types';

import './spacer.scss';
import { IClassNames, makeClassNames } from '../../../utils/styles';

export type Spaces = 20 | 30 | 60;

export interface ISpacer {
  size: Spaces;
}

const classNames = (size: Spaces): IClassNames =>
  makeClassNames({
    spacer: `spacer--${size}`,
  });

const Spacer: React.FC<ISpacer> = ({ size }) => {
  const cn = classNames(size);
  return <div className={cn.spacer} />;
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Spacer.propTypes = {
    size: PropTypes.oneOf<Spaces>([20, 30, 60]).isRequired,
  };
}

export default Spacer;
